// 接口错误

import { ISettings } from '@common/axios/requestUtil';
import { msSessionStorage } from '../utils/cache';
import { msToast } from 'msComponents';
import Dialog from '@common/components/dialog/src/main.js';
import { useBaseStore } from '@common/stores/storage';
import { getQueryString } from '@common/utils/common';

const serveErrStr = '服务异常，请稍后重试';
const netErrStr = '网络异常，请稍后重试';
const noContractStr = '您还未获得授信，是否去申请？';
const apply = '/apply/pagef';

interface IErroeCode {
  msg: string;
  refresh?: boolean;
  href?: string;
  fn?: (data?: any) => any;
  button?: boolean;
}

const errCodeMap: {
  [key: string]: IErroeCode;
} = {
  '40000002': {
    msg: serveErrStr, // 系统异常
    href: '',
  },
  '40000008': {
    msg: netErrStr, // 网络异常
    refresh: true,
  },
  '40000010': {
    msg: '系统维护中，请稍后再试', // 系统维护中
    refresh: true,
  },
  '40000011': {
    msg: serveErrStr, // 权限错误
  },
  '40080002': {
    msg: '请先实名认证', // 请先进行实名认证
    href: apply,
  },
  '40011001': {
    msg: '验证码错误，请重试', // 验证码
  },
  '40080201': {
    msg: 'inherit',
  },
  '40083027': {
    msg: noContractStr,
    href: apply,
  },
  '50060001': {
    msg: noContractStr,
    href: apply,
  },
  '40083015': {
    msg: '已有我司正在申请中的申请单', // 操作超时
    fn: (data: { message: string }) => {
      //有正在申请的申请单
      msToast({
        message: '已有我司正在申请中的申请单',
        onClose: () => {
          window.location.href = '/simplifiedApply/applying?applyNo=' + data.message;
        },
      });
    },
  },
};

/**
 * @description 不处理异常的错误code
 */
const bizErrorCodeMap = new Map([
  ['40079936', '超时'],
  ['40179903', '借款金额需为100的倍数，请调整借款金额后重新提现'],
  ['40012279', '交易密码错误，请重新输入（还剩?次机会'],
  ['40012209', '交易密码错误次数过多，已被锁定，请24小时后重试或修改交易密码'],
  ['40013001', '指纹密码失败'],
  ['40080000', 'api自定义提示：在不定场景下的报错'],
  ['40012280', '交易密码错误，请重新输入( 还剩?次机会 )'],
  ['40012277', '交易密码错误3次'],
  ['40012278', '交易密码错误4次'],
  ['40011001', '验证码错误，请重试'],
  ['40011011', '验证码过期'],
  ['50008100', '请先进行人脸识别'],
  ['50007007', '提交提现申请，反欺诈拒绝'],
  ['40079932', '可取现金额小于100'],
  ['40079934', 'UAS准入拒绝'],
  ['60001000', '申请渠道和当前渠道不一致'],
  ['40079931', '有锁定码'],
  [
    '40082021',
    '授信申请单为空 提交取现申请单时，返回的结果为null，或者status不为200,或uas返回取现申请单号为空',
  ],
  ['40000002', '缓存失效'],
  ['40079926', '抱歉，您今日提现次数已超过限制次数，为保障您账户安全，请明日再试'],
  ['40079938', '在提现准入环节通过学生锁定码拦截'],
  ['40100004', '未查询到对应活动信息'],
  ['1520', '放款生效日期必须小于账户的下个账单日'],
  ['40082004', '还款处理中'],
]);

// 交易密码相关的错误码
const pwdErrorCode = [
  '40012207',
  '40012209',
  '40013001',
  '40012277',
  '40012278',
  '40012279',
  '40012280',
];

//提单准入失败错误码
const entryFailErrorCode = [
  '40079926',
  '50007007',
  '40079932',
  '40079934',
  '60001000',
  '40082021',
  '40000002',
  '40079938',
  '40079936',
];

// 超时等网络问题的code： 缺乏治理，应该为唯一的具体的code
const networkErrorCodes = ['40000004', '40000005', '40000006', '40000007', '40000008', '40000012'];
// 未登录code： 缺乏治理，应该为唯一的具体的code
const notLoginCodes = [
  '40011005',
  '40011004',
  '40011006',
  '40011007',
  '40080001',
  '40083025',
  '40012211',
];

// errorDialog
// TODO: dialog 是 js 的库，没有具体类型，之后要确定
let errorDialog: any;
/**
 * 网络异常
 * @param code
 * @returns
 */
const isNetworkError = (code: string) => {
  return networkErrorCodes.includes(code);
};

/**
 * 未登录异常
 * @param code
 * @returns
 */
const isNotLoginError = (code: string) => {
  return notLoginCodes.includes(code);
};

/**
 * 系统异常 未登录 | 网络异常
 * @param code
 * @returns
 */
const isSystemError = (code: string) => {
  return isNetworkError(code) || isNotLoginError(code);
};

/**
 * 通用异常
 */
const handleCommonException = () => {
  if (window.location.pathname === '/npublic/error') return;
  location.href = `/npublic/error?type=404`;
};

const isOffline = () =>
  location.hostname === 'localhost' ||
  location.hostname === '127.0.0.1' ||
  location.hostname.includes('test') ||
  location.hostname.includes('dev');
const isDebug = () => isOffline() && getQueryString('debug');
/**
 * 系统异常处理
 * @param code
 * npublic/error 页面 是异常处理页面, url参数说明
 * type: 1=需要登录or空状态 2=敬请期待 3=网络异常 4=404
 * needReload: 'true' or 'false': 是否需要刷新页面，目前无此功能
 *
 */
const handleSystemException = (code: string, options?: ISettings) => {
  let redirectType: 'href' | 'replace' = 'href';
  let url: string | undefined = undefined;
  if (options?.errorRedirectUrlInfo?.default) {
    redirectType = options.errorRedirectUrlInfo.default.type;
    url = options.errorRedirectUrlInfo.default.url;
  }
  console.log(code, isNotLoginError(code), options, 'gcgc');
  // 线下环境，如果链接中带有debug字段，则不进行重定向，方便排查问题
  if (isOffline() && getQueryString('debug')) return;
  if (isNotLoginError(code)) {
    // 如果是未登录
    const { channel } = useBaseStore();
    // 未登录
    if (options?.errorRedirectUrlInfo?.unLogin) {
      redirectType = options.errorRedirectUrlInfo.unLogin.type;
      url = options.errorRedirectUrlInfo.unLogin.url;
    }
    console.log(url, 'gcgc');
    if (!url) {
      // 放置错误页无限循环刷新
      if (window.location.pathname === '/npublic/error') return;
      if (window.location.href.includes('apply/jobMini')) return;
      url = `/npublic/error?type=1`;
    }
    if (redirectType === 'href') {
      location.href = url;
    } else {
      location.replace(url);
    }
  } else if (isNetworkError(code)) {
    if (options?.errorRedirectUrlInfo?.networkError) {
      redirectType = options.errorRedirectUrlInfo.networkError.type;
      url = options.errorRedirectUrlInfo.networkError.url;
    }
    // 如果是超时了
    if (!url) {
      // 放置错误页无限循环刷新
      if (window.location.pathname === '/npublic/error') return;
      url = `/npublic/error?type=3`;
    }
    // if (redirectType === 'href') {
    //   location.href = url;
    // } else {
    //   location.replace(url);
    // }
  } else {
    if (options?.errorRedirectUrlInfo?.commonError) {
      redirectType = options.errorRedirectUrlInfo.commonError.type;
      url = options.errorRedirectUrlInfo.commonError.url;
    }
    if (url) {
      if (redirectType === 'href') {
        location.href = url;
      } else {
        location.replace(url);
      }
      return;
    }
    // 兜底
    handleCommonException();
  }
};

const handleErrorDialogByErrorCode = (
  data: { code: ResponseCode | '0' | '1' | -1; message: string },
  errorCode?: IErroeCode,
) => {
  if (!errorCode || data.code === -1) {
    if (errorDialog) errorDialog.close();
    errorDialog = Dialog({
      width: '80vw',
      text: `${data.message}`,
      submit: {
        name: '刷新重试',
        callback: () => {
          location.replace(location.href);
        },
      },
    });
  } else if (errorCode.fn) {
    msToast({
      message: errorCode.msg,
      onClose: () => {
        errorCode.fn!(data);
      },
    });
  } else if (errorCode.button === false) {
    if (errorDialog) errorDialog.close();
    errorDialog = Dialog({
      title: errorCode.msg,
      width: '80vw',
    });
  } else if (errorCode.msg === 'inherit') {
    if (errorDialog) errorDialog.close();
    errorDialog = Dialog({
      title: data.message,
      width: '80vw',
      submit: {
        name: '知道了',
        callback: () => {
          if (!errorDialog) return;
          errorDialog.close();
          errorDialog = undefined;
        },
      },
    });
  } else {
    if (errorDialog) errorDialog.close();
    errorDialog = Dialog({
      title: errorCode.msg,
      width: '80vw',
      submit: {
        name: '确定',
        callback: () => {
          if (!errorDialog) return;
          errorDialog.close();
          errorDialog = undefined;
          errHref(errorCode, { applyNo: errorCode.msg });
        },
      },
    });
  }
};

const errHref = (errorCode: IErroeCode, search: { [key: string]: any }) => {
  if (errorCode.href === null || errorCode.href === undefined) {
    return;
  }
  if (errorCode.refresh) {
    window.history.go(0);
  } else if (errorCode.href) {
    location.href = errorCode.href;
  } else {
    const { channel } = useBaseStore();
    location.href = '/finPro/user/unLogin/' + (channel || 'ayh') + '/t0';
  }
};

export type ErroeMapType = {
  msg: string;
  href?: string;
  refresh?: boolean;
  fn?: (data?: { message: string }) => any;
};

export {
  errCodeMap,
  bizErrorCodeMap,
  pwdErrorCode,
  entryFailErrorCode,
  isOffline,
  isDebug,
  isSystemError,
  handleSystemException,
  handleCommonException,
  handleErrorDialogByErrorCode,
};
